export default {
    title: 'Dashboard',
    loading: 'Loading…',
    refresh: 'Refresh',
    updatedAgo: 'Updated {seconds} s ago',
    error: 'Failed to load dashboard: {message}',
    noPermissions: 'You have no permissions. Please contact an administrator.',
    kpi: {
        sectionLabel: 'Last 24 hours',
        validations24h: 'Validations in 24 h',
        tickets: 'Tickets',
        devicesOnline: 'Active devices',
        upcomingEvents: 'Events ±7 days',
        deltaUp: '↑ {percent} % vs. yesterday',
        deltaDown: '↓ {percent} % vs. yesterday',
        deltaFlat: 'unchanged'
    },
    events: {
        title: 'Active events',
        empty: 'No events in the next 7 days',
        showAll: 'Show all →',
        progress: '{used} / {total} ({percent} %)',
        scanRate: '{count} validations in the last hour'
    },
    feed: {
        title: 'Recent scans',
        empty: 'No scans yet'
    },
    alerts: {
        title: 'Alerts',
        deviceOffline: 'Device {name} silent > 2 h',
        eventNoScans: 'Event {name} starts in < 24 h, 0 validations',
        brokenTicketset: 'Ticketset {name} has no prices — cannot scan',
        unknown: 'Unknown alert',
        empty: 'All clear'
    },
    actions: {
        title: 'Quick actions',
        importTickets: 'Import tickets',
        newEvent: 'New event',
        newDevice: 'New device'
    },
    instances: {
        title: 'Instance overview',
        name: 'Instance',
        events: 'Active events',
        scans24h: 'Scans 24 h',
        devices: 'Devices'
    }
}
